module.exports = __webpack_public_path__ + "img/home_1.7e4f16ff.jpg";